import type { Role } from '@/types/auth';

export type RoleCommunity = 'ADMIN' | 'MODERATOR' | 'MEMBER';

export type CommunityMemberStatus =
  | 'PENDING'
  | 'APPROVED'
  | 'CANCELLING'
  | 'CHURNED'
  | 'BANNED'
  | 'REJECTED';

export const COMMUNITY_MEMBER_STATUS_LABELS: Record<CommunityMemberStatus, string> = {
  PENDING: 'Chờ duyệt',
  APPROVED: 'Đang hoạt động',
  CANCELLING: 'Đang hủy',
  CHURNED: 'Đã rời đi',
  BANNED: 'Đã bị cấm',
  REJECTED: 'Bị từ chối',
};

export const ROLE_COMMUNITY_LABELS: Record<RoleCommunity, string> = {
  ADMIN: 'Quản trị',
  MODERATOR: 'Điều hành',
  MEMBER: 'Thành viên',
};

export interface CommunityOption {
  id: number;
  name: string | null;
  iconUrl: string | null;
  /**
   * Google Sheet URL the community has configured for receiving assignment
   * results. Used by GoogleSheetsSyncModal as the autofill source — falls
   * back to per-community localStorage when null/undefined.
   */
  assignmentResultSheetUrl?: string | null;
  /**
   * Human-readable Google Sheets file title (fetched server-side when the
   * URL was saved). Shown next to the URL field as helper text so the
   * admin can sanity-check the destination before syncing.
   */
  assignmentResultSheetName?: string | null;
}

export interface SpringPage<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}

export interface StudentMembership {
  membershipId: number;
  communityId: number | null;
  communityName: string | null;
  communityRole: RoleCommunity | null;
  membershipStatus: CommunityMemberStatus | null;
  cohort: number | null;
  joinedAt: string | null;
  approvedAt: string | null;
  lastActive: string | null;
}

export interface StudentSummary {
  userId: number;
  fullname: string | null;
  email: string | null;
  mobile: string | null;
  avatarUrl: string | null;
  userRole: Role | null;
  userActive: boolean | null;
  createdAt: string | null;
  memberships: StudentMembership[];
}

export interface StudentDetail {
  userId: number;
  fullname: string | null;
  email: string | null;
  mobile: string | null;
  avatarUrl: string | null;
  bio: string | null;
  userRole: Role | null;
  userActive: boolean | null;
  latitude: string | null;
  longitude: string | null;
  locationName: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  memberships: StudentMembership[];
}

export interface StudentListParams {
  communityId?: number;
  page?: number;
  size?: number;
  sort?: string;
  search?: string;
  status?: CommunityMemberStatus;
  communityRole?: RoleCommunity;
  cohort?: number;
  includeInactive?: boolean;
}
